import { render, staticRenderFns } from "./chinesePreview.vue?vue&type=template&id=dca296b4&scoped=true&"
import script from "./chinesePreview.vue?vue&type=script&lang=js&"
export * from "./chinesePreview.vue?vue&type=script&lang=js&"
import style0 from "./chinesePreview.vue?vue&type=style&index=0&id=dca296b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca296b4",
  null
  
)

export default component.exports